module.exports = __webpack_public_path__ + "img/MP.17cda1d9.png";